import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartBar } from '@fortawesome/free-solid-svg-icons';

const ReportSidebar = ({ reports, currentReportId, sidebarCollapsed }) => {
    if (!reports || reports.length === 0) {
        return <div className="p-3" style={{ color: 'white', opacity: 0.8 }}>No reports</div>;
    }

    const currentIdStr = String(currentReportId ?? '');

    return (
        <div className="list-group list-group-flush">
            {reports.map((report) => {
                const isActiveRow = String(report.report_id ?? '') === currentIdStr;
                return (
                    <Link
                        key={report.report_id}
                        to={`/report/${report.report_type}/${report.workspace.workspace_id}/${report.workspace.workspace_code}/${report.report_id}/${report.report_code}/${report.report_name}`}
                        className={`list-group-item list-group-item-action d-flex align-items-center py-1 ${isActiveRow ? 'active' : ''}`}
                        style={{
                            color: 'white',
                            backgroundColor: 'transparent',
                            border: 'none',
                            fontSize: '14px',
                            paddingLeft: '15px',
                            paddingRight: '4px',
                            gap: '6px',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        <FontAwesomeIcon icon={faChartBar} style={{ fontSize: '14px', width: '16px' }} />
                        {!sidebarCollapsed && <span>{report.report_name}</span>}
                    </Link>
                );
            })}
        </div>
    );
};

export default ReportSidebar;
